import { createFileRoute } from '@tanstack/react-router'
import { ReportCreationWizard } from 'pages/reporting/ReportCreationWizard'

export const Route = createFileRoute('/reporting/$siteID/new')({
  component: ReportCreationWizard,
  staticData: {
    title: 'New Report',
  },
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})
